var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataDrivenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 66,
    viewBox: "0 0 76 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.51435 16.7319L70.904 16.7319V7.6523C70.904 7.01448 70.6381 6.43016 70.1063 5.89934C69.5745 5.36851 68.9891 5.1031 68.3501 5.1031L7.06827 5.1031C6.42927 5.1031 5.84387 5.36851 5.31206 5.89934C4.78025 6.43016 4.51435 7.01448 4.51435 7.6523L4.51435 16.7319ZM0.36499 7.6523C0.36499 5.74575 1.00468 4.15397 2.28407 2.87695C3.56345 1.59993 5.15819 0.961426 7.06827 0.961426L68.3501 0.961426C70.2602 0.961426 71.8549 1.59993 73.1343 2.87695C74.4137 4.15397 75.0534 5.74575 75.0534 7.6523V26.6077L4.51435 26.6077L4.51435 52.254C4.51435 52.8918 4.78025 53.4761 5.31206 54.007C5.84387 54.5378 6.42927 54.8032 7.06827 54.8032L26.3939 54.8032L26.3939 58.9449L7.06827 58.9449C5.15819 58.9449 3.56345 58.3064 2.28407 57.0294C1.00468 55.7523 0.36499 54.1606 0.36499 52.254L0.36499 7.6523ZM48.6728 65.3168L33.9105 50.5818L36.8472 47.6505L48.6728 59.4067L72.2764 35.8468L75.2131 38.8257L48.6728 65.3168ZM4.51435 7.6523L4.51435 52.254C4.51435 52.8918 4.78025 53.4761 5.31206 54.007C5.84387 54.5378 6.42927 54.8032 7.06827 54.8032H4.51435L4.51435 35.9265L4.51435 47.7064L4.51435 5.1031H7.06827C6.42927 5.1031 5.84387 5.36851 5.31206 5.89934C4.78025 6.43016 4.51435 7.01448 4.51435 7.6523Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataDrivenIcon);
export default __webpack_public_path__ + "static/media/DataDriven_Icon.df92a83cfbd7f57f0ffeab2fc71f6783.svg";
export { ForwardRef as ReactComponent };